<script>

import EmployeeForm from "@/components/users/EmployeeForm.vue";

export default {
    components: {EmployeeForm},
    data() {
        return {
            user: {
                first_name: '',
                last_name: '',
                email: '',
                companies_ids: [],
                pesel: '',
                bank_account_number: '',
                auto_settlement: 0,
                tax_active: 0,
                tax_rate: ''
            }
        }
    }
}

</script>
<template>
    <div class="trainings-create">

        <employee-form :user="user"/>

    </div>
</template>
